import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminWorkspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useRevokeDeveloperAccessMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.revoke(e.workspaceId, e.data),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.status(n.workspaceId) });
		}
	});
};
//#endregion
export { i as useRevokeDeveloperAccessMutation };
